"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.membershipRequestFactory = exports.existingMembershipFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
const Mocks = require("../../../mocks");
const affiliation_path_factory_1 = require("../../common/factories/affiliation-path.factory");
exports.existingMembershipFactory = Factory.Sync.makeFactory({
    address: null,
    date_of_birth: Mocks.dates.date2000,
    email: Mocks.persona.email,
    gender: 'male',
    legal: null,
    membership_id: Factory.each(() => uuid_1.v4()),
    membership_number: '1234567',
    membership_is_obo: true,
    name: Mocks.persona.full_name,
    organization_city_state: null,
    organization_contact_email: 'Jane Doe',
    organization_contact_phone: '555-555-5555',
    organization_id: Mocks.orgClub.id,
    organization_name: Mocks.orgClub.name,
    persona_id: 1,
    phone: '555-555-5554',
    status: 'Active',
});
exports.membershipRequestFactory = Factory.Sync.makeFactory({
    affiliation_path: affiliation_path_factory_1.affiliationPathFactory.build(),
    profile_image: Mocks.persona.profile_image,
    existing_memberships: exports.existingMembershipFactory.buildList(1),
    id: Factory.each(() => uuid_1.v4()),
    name: Mocks.persona.full_name,
    email: Mocks.persona.email,
    gender: 'male',
    date_of_birth: Mocks.dates.date2000,
    phone: '555-555-5553',
    address: null,
    legal: null,
    organization_ids: [Mocks.orgClub.id, Mocks.orgNgb.id],
    membership_definition_name: 'Test Membership',
    membership_definition_id: Factory.each(() => uuid_1.v4()),
    membership_definition_organization_id: Mocks.orgNgb.id,
    requesting_persona_id: Mocks.persona.id,
    requested_membership_id: Factory.each(() => uuid_1.v4()),
    requested_membership_is_obo: true,
    requested_membership_status: 'Requested',
    requested_membership_number: '1234568',
    requested_membership_organization_id: Mocks.orgClub.id,
    requested_membership_organization_name: Mocks.orgClub.name,
    requested_membership_organization_city_state: null,
    requested_membership_organization_contact_name: 'Suzan Smith',
    requested_membership_organization_contact_email: 'test@example.com',
    requested_membership_organization_contact_phone: '555-555-5552',
    status: 'approved',
    created_at: Mocks.dates.date2000,
    started_at: Mocks.dates.date2000,
    updated_at: Mocks.dates.date2000,
});
